'use client';

import { useParams } from 'next/navigation';
import { useEffect } from 'react';
import { CreateErrandForm } from './components/create-errand-form';

export default function CreateErrandPage() {
  const { customerId } = useParams<{ customerId: string }>();

  useEffect(() => {
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = 'white';
    return () => {
      document.body.style.backgroundColor = prev;
    };
  }, []);

  return <CreateErrandForm customerId={customerId} />;
}
